import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {grayscale} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  itemContainer: {
    width: '100%',
    paddingVertical: indent * 1.1,
    paddingHorizontal: indent * 0.9,
    borderTopWidth: 1,
    borderColor: alto,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  infoIcon: {
    color: grayscale,
  },
  sortOptionContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flex: 1,
    minWidth: 0,
    marginRight: indent * 0.5,
  },
  sortLabel: {
    flexShrink: 1,
    minWidth: 0,
  },
  icon: {
    marginRight: indent * 1.15,
    fontSize: 25,
    marginTop: 2,
  },
});
